import { Card, Container } from "@mui/material";
import DashboardHeader from "../DashboardHeader";

export default function EmbeddedLinkDashboard(props) {
    const { dashboard = {} } = props;
    const { title, description, embedded_link: url } = dashboard;

    return (
        <>
            <Container>
                <DashboardHeader title={title} subtitle={description} />
            </Container>
            <Container sx={{ marginTop: 5, padding: 0, height: "100%" }} maxWidth={false}>
                <Card sx={{ width: "100%", height: "100%" }}>
                    <iframe
                        title={title}
                        src={url}
                        width={"100%"}
                        height={"100%"}
                        allowFullScreen={true}
                        style={{
                            border: 0,
                        }}
                    ></iframe>
                </Card>
            </Container>
        </>
    );
}
